module.exports = __webpack_public_path__ + "static/img/19wr.35f85758.webp";